export default "__VITE_ASSET__BQr7zECk__"